import { createApp } from 'vue'
import { createPinia } from 'pinia'
import Antd from 'ant-design-vue'
import 'ant-design-vue/dist/reset.css'

import App from './App.vue'
import router from './router'
import i18n from './i18n'

// 全局样式
import './assets/styles/global.less'

// 性能监控和优化
import { setupVisibilityOptimization } from '@/utils/performance'

// 初始化stores
import { initializeStores } from '@/stores'

// 全局 Promise 错误处理
window.addEventListener('unhandledrejection', (event) => {
  console.error('Unhandled promise rejection:', event.reason)
  event.preventDefault()
})

window.addEventListener('error', (event) => {
  console.error('Global error:', event.error)
})

const app = createApp(App)

const pinia = createPinia()
app.use(pinia)
app.use(router)
app.use(i18n)
app.use(Antd)

// 初始化所有stores
initializeStores()

// 设置性能优化
setupVisibilityOptimization()

app.mount('#app')